import React, { useCallback, useRef } from 'react';
import toastr from 'toastr';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB,
  FILE_UPLOAD_FORMAT_OPTIONS,
  SIGNATURE_FILE_TYPE,
} from '../../../../HelperMethods/constants';
import { useAttachmentFileChangeHook } from '../../../../HelperMethods/CommonHooks';
import DropdownModal from './DropdownModal';
import styles from './ManualUploadDropdownModal.module.css';
import { joyn2UserPropType } from '../../../../common/prop-types';

export default function ManualUploadDropdownModal({ openModal, setOpenModal, onFileUploaded, loggedInUser }) {
  const fileInputRef = useRef();
  const onPdfUploaded = useCallback(
    (uploadObj) => {
      const pdfUploadObj = { ...uploadObj, fileType: SIGNATURE_FILE_TYPE.PDF };
      onFileUploaded(pdfUploadObj);
      setOpenModal(false);
    },
    [onFileUploaded, setOpenModal]
  );
  const handleError = useCallback((errorMessage) => {
    if (errorMessage) toastr.error(errorMessage);
  });
  const [uploading, onFileChange] = useAttachmentFileChangeHook(
    onPdfUploaded,
    DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB,
    handleError,
    loggedInUser
  );
  const onUploadButtonClicked = useCallback(() => {
    fileInputRef.current.click();
  }, [fileInputRef]);
  return (
    <DropdownModal
      openModal={openModal}
      setOpenModal={setOpenModal}
      title="Manual Signature"
      content={
        <ol className={styles.steps}>
          <li>Download and print the form</li>
          <li>Sign the form and scan the document</li>
          <li>
            Upload the Scanned document
            <br />
            Choose file&nbsp;&nbsp;
            <Button
              type="button"
              style={{ marginBottom: '16px' }}
              loading={uploading}
              disabled={uploading}
              icon="cloud upload"
              onClick={onUploadButtonClicked}
              className="no-print"
            />
            <input
              style={{ display: 'none' }}
              ref={fileInputRef}
              accept={FILE_UPLOAD_FORMAT_OPTIONS.pdf.acceptedExtension}
              type="file"
              onChange={onFileChange}
            />
          </li>
        </ol>
      }
    />
  );
}

ManualUploadDropdownModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  loggedInUser: joyn2UserPropType.isRequired,
  onFileUploaded: PropTypes.func.isRequired,
};
